export class RegExpHelper {
    static hexColor(): RegExp {
        return /^#[0-9A-F]{6}$/i;
    }
}
